import { gql } from "@apollo/client"

export const GET_TEMPLATE_VIEW_MODE = gql`
  query FormRequestViewMode(
    $staff_id: ID!
    $organization_id: ID
    $enterprise_id: ID
    $participant_id: ID!
    $idTemplate: ID!
    $supervision_staff_membership_id: ID
    $type: ID!
    $idStamp: ID
    $retrieveLatestAssessment: Boolean
    $forceStampSnapshot: Boolean
  ) {
    template(
      staff_id: $staff_id
      participant_id: $participant_id
      idTemplate: $idTemplate
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      supervision_staff_membership_id: $supervision_staff_membership_id
      type: $type
      idStamp: $idStamp
      retrieveLatestAssessment: $retrieveLatestAssessment
      forceStampSnapshot: $forceStampSnapshot
    ) {
      template_title
      template_description
      audit_type
      blocks {
        idBlock
        block_name
        block_title
        total_fields
        index
        fields {
          field_name
          field_label
          field_type
          field_type_subtype
          description
          field_description
          multi_fields {
            field_name
            field_type
            field_type_subtype
            field_label
            multi_fields {
              field_name
              field_type
              field_type_subtype
              field_label
            }
          }
          field_options {
            label
            value
          }
        }
      }
      values
    }
  }
`

// Note: Duplicate of src\pages\Participant\ParticipantProfile\queries.js::PARTICIPANT_BLOCK
export const PARTICIPANT_BLOCK = gql`
  query ViewModeParticipantBlock(
    $participant_id: ID!
    $idBlock: ID!
    $type: ID
    $organization_id: ID
    $enterprise_id: ID
  ) {
    block(
      idBlock: $idBlock
      type: $type
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      fields {
        idField
        field_type
        field_type_subtype
        field_description
        field_conditional
        field_label
        field_name
        field_visibility
        field_options {
          ...fieldOptions
          __typename
        }
        field_validation {
          ...fieldValidation
          __typename
        }
        multi_fields {
          ...multiField
          multi_fields {
            ...multiField
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
    blockSaved(
      participant_id: $participant_id
      block_name: $idBlock
      organization_id: $organization_id
    ) {
      data
      __typename
    }
  }

  fragment fieldOptions on TypeFieldOptions {
    label
    value
    __typename
  }

  fragment fieldValidation on TypeFieldValidation {
    required
    min
    max
    maxlength
    file_extension
    file_size
    file_multi_files
    file_firestore_storage
    file_cloud_storage
    file_is_shared
    file_is_renameable
    __typename
  }

  fragment multiField on TypeMultiField {
    field_name
    field_type
    field_type_subtype
    field_label
    field_options {
      ...fieldOptions
      __typename
    }
    field_validation {
      ...fieldValidation
      __typename
    }
    __typename
  }
`

export const GET_STAFF = gql`
  query GetStaffname($staff_id: ID!, $organization_id: ID!) {
    user(staff_id: $staff_id, organization_id: $organization_id) {
      staff_name_first
      staff_name_last
      staff_membership_id
    }
    userNameOnly: getStaffName(
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      data
    }
  }
`

export const GET_BLOCKS_SAVED = gql`
  query BlocksSaved($idStamp: ID!) {
    getBlockSavedByIdStamp(idStamp: $idStamp) {
      data
    }
  }
`
